import React from "react";

import { faCheckDouble, faHistory, faThumbsUp } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { faUsers } from "@awesome.me/kit-4c83d50d0d/icons/kit/custom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ReactComponent as FellowWordmark } from "~/legacy-assets/images/logos/fellow-wordmark-black-solid.svg";
import { isNative } from "~/lib/utils";

import { AuthBase } from "../AuthBase";
import { Button, LoginHint } from "../components";
import { VideoPane, WhitelabelPane } from "../panes";
import type { AuthProps } from "../types";

import styles from "../css/Auth.module.css";

interface RootState {
	errorMessage: string | undefined;
}

export default class Root extends AuthBase<AuthProps, RootState> {
	state: RootState = {
		errorMessage: undefined,
	};

	getPaneComponent() {
		const { subdomain } = window.INITIAL_STATE;

		if (subdomain) {
			return WhitelabelPane;
		}

		return VideoPane;
	}

	getPaneProps() {
		const { subdomain } = window.INITIAL_STATE;

		if (subdomain) {
			return { account: this.context.account, bgStyle: "wave" as const };
		}

		return { bgStyle: "custom" as const };
	}

	componentDidMount() {
		super.componentDidMount();

		if (isNative) {
			this.props.history.push("/auth/login/");
		}
	}

	renderStep() {
		return (
			<div className={styles.authFlex}>
				<FellowWordmark className={styles.wordMark}></FellowWordmark>

				<h1>Start your next team meeting off right.</h1>

				<div className={styles.sellingPoints}>
					<div className={styles.sellingPoint}>
						<div>
							<FontAwesomeIcon icon={faUsers} />
						</div>
						Create agendas collaboratively
					</div>
					<div className={styles.sellingPoint}>
						<div>
							<FontAwesomeIcon icon={faCheckDouble} />
						</div>{" "}
						Centralize all your action items
					</div>
					<div className={styles.sellingPoint}>
						<div>
							<FontAwesomeIcon icon={faHistory} />
						</div>{" "}
						Keep track of discussions over time
					</div>
					<div className={styles.sellingPoint}>
						<div>
							<FontAwesomeIcon icon={faThumbsUp} />
						</div>{" "}
						Give &amp; receive feedback as work happens
					</div>
				</div>

				<Button primary onClick={this.navigateTo("/auth/signup/")}>
					Get started
				</Button>
			</div>
		);
	}

	renderFooter() {
		return <LoginHint />;
	}
}
